import { cn } from '@bem-react/classname';

export const cnKhFooter = cn('KhFooter');
